<!-- <header>
      <h2>Step {{ selectedIndex + 1 }}/{{ steps.length }}</h2>
    </header> -->
<div class="form" id="stepper" fxLayout="row wrap" (dblclick)="wow($event)">
    <div class="stepper" fxFlex="100">
        <mat-card>
            <mat-card-content>
                <!-- <button class="example-nav-button" cdkStepperPrevious>&larr;</button> -->
                <!-- <div *ngFor="let step of steps; let i = index">
                            <button class="example-step" [class.example-active]="selectedIndex === i"
                                (click)="selectStepByIndex(i)">
                                Step {{ i + 1 }}
                            </button><br>
                        </div> -->
                <button class="example-step" [class.example-active]="selectedIndex === 0"
                    (click)="selectStepByIndex(0)">
                    <div class="stepperButton">
                        <div fxFlex="3.2em">
                            <div class="circleBase type2">
                                <div class="circleBase type1">
                                    <i id="i1" class="flaticon-basic-details"></i>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="label" class="btnLabel" fxFlex="auto">
                            <span id="step1">Basic Details
                            </span>
                        </div>
                    </div>
                </button>
                <svg height="7rem" width="4rem" class="example-step"
                    [class.example-active]="selectedIndex === 1 || selectedIndex === 2">
                    <line x1="1.89rem" y1="0" x2="1.89rem" y2="7rem" />
                </svg>
                <button class="example-step" [class.example-active]="selectedIndex === 1"
                    (click)="selectStepByIndex(1)">
                    <div class="stepperButton">
                        <div fxFlex="3.2em">
                            <div class="circleBase type2">
                                <div class="circleBase type1">
                                    <i id="i2" class="flaticon-communication"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="label" class="btnLabel" fxFlex="auto">
                            <span id="step2">Communication
                            </span>
                        </div>
                    </div>
                </button>
                <svg height="7rem" width="4rem" class="example-step" [class.example-active]="selectedIndex === 2">
                    <line x1="1.89rem" y1="0" x2="1.89rem" y2="7rem" />
                </svg>
                <button class="example-step" [class.example-active]="selectedIndex === 2"
                    (click)="selectStepByIndex(2)">
                    <div class="stepperButton">
                        <div fxFlex="3.2em">
                            <div class="circleBase type2">
                                <div class="circleBase type1">
                                    <i id="i3" class="flaticon-commercials"></i>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="label" class="btnLabel" fxFlex="auto">
                            <span id="step3">Commercials
                            </span>
                        </div>
                    </div>

                </button>
                <!-- <button class="example-nav-button" cdkStepperNext>&rarr;</button> -->
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div class="formContent" fxFlex="100">
    <mat-card>
        <mat-card-content>
            <div [ngTemplateOutlet]="selected ? selected.content : null"></div>
        </mat-card-content>
    </mat-card>
</div>